/**
 * admin-doctor-delete.js — 醫師管理「刪除確認」Modal 姓名 slot 綁定（/admin/doctors）
 *
 * bug 背景（已由互動測試證實）：卡片刪除鈕 [data-modal-trigger="#doctor-delete-modal"][data-doctor-name]
 * 開啟共用 alertdialog #doctor-delete-modal，內文 [data-doctor-name-slot] 應顯示該醫師姓名，但
 * modal.js 是通用 dialog primitive（見 components/modal.js 檔頭），其 bindTriggers() 只讀
 * data-modal-trigger 決定開哪個 modal，從未讀過 data-doctor-name、也不該知道
 * [data-doctor-name-slot] 這種頁面專屬語意——整個專案原本沒有任何模組把兩者接起來
 * （admin-doctor-filter.js 只管 tabs 篩選、doctors-modal-form.js 只管新增 Modal 欄位），
 * slot 因此恆顯示靜態 fallback「這位」，不論刪哪一位醫師。
 *
 * 修復：本檔補上這段頁面專屬綁定；modal.js 本身不動（不影響其 Esc 關閉 / focus-trap 等既有行為）。
 *
 * 行為：比照 modal.js 的 bindTriggers() 慣例，逐一為觸發鈕掛 click listener（與 modal.js 各自獨立
 * 掛在同一元素上，互不干擾、無需協調執行順序——本檔只寫 modal 內文字節點，modal.js 的
 * 開啟/動畫/focus 各自照舊）。點擊時讀觸發鈕的 data-doctor-name，寫入 modal 內
 * [data-doctor-name-slot]；空值或缺屬性 fallback 回原靜態文案「這位」，不留空字串。
 *
 * 設計：root 守門早退（無 #doctor-delete-modal 或內部無 slot 即 return，非本頁 no-op）。
 * 冪等綁定（data-doctor-delete-bound 旗標，比照 modal.js dataset.modalBound 慣例），避免
 * 重入 / HMR 雙綁導致同一次點擊觸發多次寫入。
 *
 * 載入：由 src/admin.js import。
 */

const MODAL_SELECTOR = '#doctor-delete-modal';
const TRIGGER_SELECTOR = `[data-modal-trigger="${MODAL_SELECTOR}"]`;
const SLOT_SELECTOR = '[data-doctor-name-slot]';
const FALLBACK_NAME = '這位';

function bindDeleteTriggers(root = document) {
  const modal = root.querySelector(MODAL_SELECTOR);
  if (!modal) return; // 非 doctors 頁（或 modal 尚未在 DOM 內）→ no-op

  const slot = modal.querySelector(SLOT_SELECTOR);
  if (!slot) return;

  const triggers = root.querySelectorAll(TRIGGER_SELECTOR);
  triggers.forEach((trigger) => {
    if (trigger.dataset.doctorDeleteBound === '1') return; // 冪等，避免重入雙綁
    trigger.dataset.doctorDeleteBound = '1';
    trigger.addEventListener('click', () => {
      const name = (trigger.getAttribute('data-doctor-name') || '').trim();
      slot.textContent = name || FALLBACK_NAME;
    });
  });
}

// module script 為 defer：DOM 已解析。仍守 readyState 以相容非 module 載入情境。
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bindDeleteTriggers(), { once: true });
} else {
  bindDeleteTriggers();
}

export { bindDeleteTriggers };
